import React, {useState, useEffect, useContext } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../css/zInternal_css.css';
import { AddEstimateModal } from './Modal_AddEstimate';
import { ViewEstimateModal } from './Modal_ViewEstimate';
import { AddInvoiceModal_Projects } from './Modal_AddInvoice_Projects';
import { ViewInvoiceModal_Projects } from './Modal_ViewInvoice_Projects';

export function ProjectDetailsModal(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [addEstimateModal, setAddEstimateModal] = useState(false);
    let [viewEstimateModal, setViewEstimateModal] = useState(true);
    let [addInvoiceModal, setAddInvoiceodal] = useState(false);
    let [viewInvoiceModal, setViewInvoiceModal] = useState(false);



    let [estimatesColor, setestimatesColor] = useState('outline')
    let [project_expensesColor, setPaidPartialColor] = useState('clear');

    {/*useEffect(() => {

        //alert('In Occupied Detailed Data');
        //alert(props.openModal);

        if(props.openModal == true)
        {

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002A_De',
                    user: acctID,
                    xExpenseID: props.data.expenseID,
                    sessionID: sessionID,
    
                }),
            }
        
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
        
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');


                    setViewExpenseDetailData((prevViewExpenseDetailData) => {
                        return prevViewExpenseDetailData.concat({
                            expenseID: cols[0],
                            supplierName: cols[1],
                            supplierPhoneNumber: cols[2],
                            expenseDescription: cols[3],
                            dateLogged: new Date(cols[4]).toISOString().substr(0, 10),
                            unitAmount: parseFloat(cols[5]).toFixed(2),
                            quantity: cols[6],
                            totalAmount: parseFloat(cols[7]).toFixed(2),
                            paymentType: cols[8],
                            attachment: cols[9],
                        })

                    });
        
                }    
            })
        }
    }, [props.openModal]);*/}


    function estimatesHandler()
    {
        setViewEstimateModal(true);
        setViewInvoiceModal(false);
        setestimatesColor('outline');
        setPaidPartialColor('clear');
    }

    function project_expensesHandler()
    {
        setViewEstimateModal(false);
        setViewInvoiceModal(true);
        setestimatesColor('clear');
        setPaidPartialColor('outline');

    }


    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>

        <IonHeader>
            <IonGrid>
                <IonRow>
                    <IonCol size='6'>
                        <IonButton fill={estimatesColor} onClick={() => estimatesHandler()}> Estimates </IonButton>
                    </IonCol>
                    <IonCol size='6'>
                        <IonButton fill={project_expensesColor} onClick={() => project_expensesHandler()}> Invoices </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                {viewEstimateModal == true && <IonCol style={{ textAlign: 'left' }}> <IonButton onClick={() => setAddEstimateModal(true)}>Add</IonButton></IonCol>}
                {viewInvoiceModal == true && <IonCol style={{ textAlign: 'right' }}> <IonButton onClick={() => setAddInvoiceodal(true)}>Add</IonButton></IonCol>}
                </IonRow>
            </IonGrid>
        </IonHeader>
        
        {/*<<IonGrid class='appGridContent'>
            
                IonRow>
                    <IonCol> Project ID</IonCol>
                </IonRow>
                <IonRow>
                    <IonCol> {props.data.projectID} </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>Estimates</IonCol>
                    <IonCol>Expenses</IonCol>
            </IonRow>*
                <IonRow>
                    <IonCol> {props.data.estimates} </IonCol>
                    <IonCol> {props.data.expenses} </IonCol>
        </IonRow>
                <IonRow>
                    <IonCol> <IonButton onClick={() => setAddEstimateModal(true)}>Add</IonButton></IonCol>
                    <IonCol> <IonButton onClick={() => setAddExpenseModal(true)}>Add</IonButton></IonCol>
                </IonRow>
                <IonRow>
                    <IonCol> <IonButton onClick={() => setViewEstimateModal(true)}>View</IonButton></IonCol>
                    <IonCol> <IonButton onClick={() => setViewExpenseModal(true)}>View</IonButton></IonCol>

                </IonRow>
        </IonGrid>*/}

        <AddEstimateModal  openModal={ addEstimateModal } closeModal={() => setAddEstimateModal(false)} data={{
                                            projectID: props.data.projectID, 
                                            estimates: props.data.estimates,
                                            expenses: props.data.expenses,
                                            }}></AddEstimateModal>
        {/*<ViewEstimateModal  openModal={ viewEstimateModal } closeModal={() => setViewEstimateModal(false)} data={{
                                            projectID: props.data.projectID, 
                                            estimates: props.data.estimates,
                                            expenses: props.data.expenses,
                                            }}></ViewEstimateModal>*/}

        {viewEstimateModal == true && <ViewEstimateModal closeModal={() => setViewEstimateModal(false)} data={{
                                            projectID: props.data.projectID, 
                                            estimates: props.data.estimates,
                                            expenses: props.data.expenses,
                                            }}></ViewEstimateModal>}

        
        <AddInvoiceModal_Projects  openModal={ addInvoiceModal } closeModal={() => setAddInvoiceodal(false)} data={{
                                            projectID: props.data.projectID, 
                                            estimates: props.data.estimates,
                                            expenses: props.data.expenses,
                                            }}></AddInvoiceModal_Projects>

        {viewInvoiceModal == true && <ViewInvoiceModal_Projects  openModal={ viewInvoiceModal } closeModal={() => setViewInvoiceModal(false)}data={{
                                            projectID: props.data.projectID, 
                                            estimates: props.data.estimates,
                                            expenses: props.data.expenses,
                                            }}></ViewInvoiceModal_Projects>}


        <IonGrid class='modal_footer_button_center'>
            <IonButton onClick={closeModalHandler}> Close </IonButton>
        </IonGrid>
    </IonModal>) : null}
    </React.Fragment>
    )
}